// Fichier : pages/Admin/ventesPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPage.css';

const VentesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-page">
      <h2>Gestion des ventes</h2>
      <div className="admin-buttons">
        <button onClick={() => navigate('/admin/ventes/ajouter')}>Ajouter un bien</button>
        <button onClick={() => navigate('/admin/ventes/modifier')}>Modifier un bien</button>
        <button onClick={() => navigate('/admin/ventes/supprimer')}>Supprimer un bien</button>
      </div>
    </div>
  );
};

export default VentesPage;